import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CompanyProvider } from './context/CompanyContext';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Providers from './context/Providers';
import { RegisterProvider } from './context/companyregister';
import { ModuleAccessProvider } from './context/moduleaccessContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter >
      <Providers>
        <RegisterProvider>
          <ModuleAccessProvider>
            <App />
          </ModuleAccessProvider>
        </RegisterProvider>
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
);
